// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.ae-preview-ext_modal-content_uCUqm {
        max-width: 750px;
}

.ae-preview-ext_body_RWG9I {
        background: var(--ui-modal-background);
        padding: 1.5rem 2.25rem;
        min-height: 150px;
        max-height: calc(100vh - 250px);
        overflow-y: auto;
}

.ae-preview-ext_tab-button-enable_A9tOq,
.ae-preview-ext_tab-button-unable_CJiS5 {
        border: none;
        transition: filter 0.2s ease;
        height: 30px;
        line-height: 1.5;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
}

.ae-preview-ext_tab-button-enable_A9tOq {
        filter: brightness(0.8)
}

.ae-preview-ext_tab-button-enable_A9tOq:hover,
.ae-preview-ext_tab-button-unable_CJiS5:hover {
        filter: brightness(1.2)
}

.ae-preview-ext_tab-button-enable_A9tOq:active,
.ae-preview-ext_tab-button-unable_CJiS5:active {
        filter: brightness(0.5)
}

/* For small screens, such as in the embed */

@media (max-height: 600px) {
        .ae-preview-ext_modal-content_uCUqm {
                margin: 50px auto;
        }

        .ae-preview-ext_body_RWG9I {
                max-height: calc(100vh - 150px);
        }
}

.ae-preview-ext_setting_QS5uH {
        display: flex;
        flex-direction: column;
        padding: 0.5rem 1rem;
        margin: 0.25rem 0;
        border-radius: 4px;
}

.ae-preview-ext_setting_QS5uH.ae-preview-ext_active_vrZNx {
        background: var(--badge-background);
}

.ae-preview-ext_setting_QS5uH:hover,
.ae-preview-ext_setting_QS5uH:focus-within {
        background: var(--badge-border);
}

.ae-preview-ext_label_jCG5a {
        height: 32px;
        display: flex;
        flex-direction: row;
        align-items: center;
}

.ae-preview-ext_setting_QS5uH table {
        border-collapse: collapse;
}

.ae-preview-ext_setting_QS5uH tr,
.ae-preview-ext_setting_QS5uH td,
.ae-preview-ext_setting_QS5uH th {
        padding: 0;
        margin: 0;
        border: 1px solid var(--ui-tertiary);
}

.ae-preview-ext_checkbox_n1g2m {
        margin-right: 0.5rem;
}

.ae-preview-ext_help-icon__SfDK {
        position: relative;
        border: 0;
        background-color: transparent;
        width: 20px;
        height: 20px;
        background-size: 100%;
        margin-left: 0.5rem;
        cursor: pointer;
}

.ae-preview-ext_help-icon__SfDK img {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        filter: var(--filter-icon-black);
}

.ae-preview-ext_custom-stage-size_yAJ16>* {
        margin-right: 0.5rem;
}

.ae-preview-ext_custom-stage-size-input_GVJit {
        width: 80px;
}

.ae-preview-ext_info_EGK7a {
        margin-bottom: 0.25rem;
}

.ae-preview-ext_header__mRsF {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 0.5rem 0 0 0;
        font-weight: bold;
}

.ae-preview-ext_divider_HLna4 {
        flex-grow: 1;
        margin-left: 1rem;
        border-top: 1px dashed var(--ui-tertiary);
}

.ae-preview-ext_button_EWN7A {
        font-family: inherit;
        font-size: 14px;
        background-color: var(--looks-secondary);
        color: white;
        border: none;
        padding: 0.5rem 1rem;
        margin: 0;
        border-radius: 4px;
        cursor: pointer;
        font-family: inherit;
        font-weight: bold;
}

.ae-preview-ext_button_EWN7A:active,
.ae-preview-ext_button_EWN7A:focus-within {
        box-shadow: 0 0 0 3px var(--looks-transparent);
}

.ae-preview-ext_warning_arnJK {
        padding: 0.5rem 1rem;
        margin: 0.25rem 0;
        border-radius: 4px;
        background: rgb(233, 233, 53);
        color: var(--text-primary-default);
}

.ae-preview-ext_svgItem_aT8q4{
        margin-bottom: -75px;
}

svg{
        overflow: visible !important; 
}`, "",{"version":3,"sources":["webpack://./src/components/ae-preview-ext/ae-preview-ext.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;QACQ,gBAAgB;AACxB;;AAEA;QACQ,sCAAsC;QACtC,uBAAuB;QACvB,iBAAiB;QACjB,+BAA+B;QAC/B,gBAAgB;AACxB;;AAEA;;QAEQ,YAAY;QACZ,4BAA4B;QAC5B,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;AAC/B;;AAEA;QACQ;AACR;;AAEA;;QAEQ;AACR;;AAEA;;QAEQ;AACR;;AAEA,4CAA4C;;AAE5C;QACQ;gBACQ,iBAAiB;QACzB;;QAEA;gBACQ,+BAA+B;QACvC;AACR;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,oBAAoB;QACpB,iBAAiB;QACjB,kBAAkB;AAC1B;;AAEA;QACQ,mCAAmC;AAC3C;;AAEA;;QAEQ,+BAA+B;AACvC;;AAEA;QACQ,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,mBAAmB;AAC3B;;AAEA;QACQ,yBAAyB;AACjC;;AAEA;;;QAGQ,UAAU;QACV,SAAS;QACT,oCAAoC;AAC5C;;AAEA;QACQ,oBAAoB;AAC5B;;AAEA;QACQ,kBAAkB;QAClB,SAAS;QACT,6BAA6B;QAC7B,WAAW;QACX,YAAY;QACZ,qBAAqB;QACrB,mBAAmB;QACnB,eAAe;AACvB;;AAEA;QACQ,cAAc;QACd,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,gCAAgC;AACxC;;AAEA;QACQ,oBAAoB;AAC5B;;AAEA;QACQ,WAAW;AACnB;;AAEA;QACQ,sBAAsB;AAC9B;;AAEA;QACQ,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,oBAAoB;QACpB,iBAAiB;AACzB;;AAEA;QACQ,YAAY;QACZ,iBAAiB;QACjB,yCAAyC;AACjD;;AAEA;QACQ,oBAAoB;QACpB,eAAe;QACf,wCAAwC;QACxC,YAAY;QACZ,YAAY;QACZ,oBAAoB;QACpB,SAAS;QACT,kBAAkB;QAClB,eAAe;QACf,oBAAoB;QACpB,iBAAiB;AACzB;;AAEA;;QAEQ,8CAA8C;AACtD;;AAEA;QACQ,oBAAoB;QACpB,iBAAiB;QACjB,kBAAkB;QAClB,6BAA6B;QAC7B,kCAAkC;AAC1C;;AAEA;QACQ,oBAAoB;AAC5B;;AAEA;QACQ,4BAA4B;AACpC","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content {\n        max-width: 750px;\n}\n\n.body {\n        background: var(--ui-modal-background);\n        padding: 1.5rem 2.25rem;\n        min-height: 150px;\n        max-height: calc(100vh - 250px);\n        overflow-y: auto;\n}\n\n.tab-button-enable,\n.tab-button-unable {\n        border: none;\n        transition: filter 0.2s ease;\n        height: 30px;\n        line-height: 1.5;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n}\n\n.tab-button-enable {\n        filter: brightness(0.8)\n}\n\n.tab-button-enable:hover,\n.tab-button-unable:hover {\n        filter: brightness(1.2)\n}\n\n.tab-button-enable:active,\n.tab-button-unable:active {\n        filter: brightness(0.5)\n}\n\n/* For small screens, such as in the embed */\n\n@media (max-height: 600px) {\n        .modal-content {\n                margin: 50px auto;\n        }\n\n        .body {\n                max-height: calc(100vh - 150px);\n        }\n}\n\n.setting {\n        display: flex;\n        flex-direction: column;\n        padding: 0.5rem 1rem;\n        margin: 0.25rem 0;\n        border-radius: 4px;\n}\n\n.setting.active {\n        background: var(--badge-background);\n}\n\n.setting:hover,\n.setting:focus-within {\n        background: var(--badge-border);\n}\n\n.label {\n        height: 32px;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n}\n\n.setting table {\n        border-collapse: collapse;\n}\n\n.setting tr,\n.setting td,\n.setting th {\n        padding: 0;\n        margin: 0;\n        border: 1px solid var(--ui-tertiary);\n}\n\n.checkbox {\n        margin-right: 0.5rem;\n}\n\n.help-icon {\n        position: relative;\n        border: 0;\n        background-color: transparent;\n        width: 20px;\n        height: 20px;\n        background-size: 100%;\n        margin-left: 0.5rem;\n        cursor: pointer;\n}\n\n.help-icon img {\n        display: block;\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        filter: var(--filter-icon-black);\n}\n\n.custom-stage-size>* {\n        margin-right: 0.5rem;\n}\n\n.custom-stage-size-input {\n        width: 80px;\n}\n\n.info {\n        margin-bottom: 0.25rem;\n}\n\n.header {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        margin: 0.5rem 0 0 0;\n        font-weight: bold;\n}\n\n.divider {\n        flex-grow: 1;\n        margin-left: 1rem;\n        border-top: 1px dashed var(--ui-tertiary);\n}\n\n.button {\n        font-family: inherit;\n        font-size: 14px;\n        background-color: var(--looks-secondary);\n        color: white;\n        border: none;\n        padding: 0.5rem 1rem;\n        margin: 0;\n        border-radius: 4px;\n        cursor: pointer;\n        font-family: inherit;\n        font-weight: bold;\n}\n\n.button:active,\n.button:focus-within {\n        box-shadow: 0 0 0 3px var(--looks-transparent);\n}\n\n.warning {\n        padding: 0.5rem 1rem;\n        margin: 0.25rem 0;\n        border-radius: 4px;\n        background: rgb(233, 233, 53);\n        color: var(--text-primary-default);\n}\n\n.svgItem{\n        margin-bottom: -75px;\n}\n\nsvg{\n        overflow: visible !important; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `ae-preview-ext_modal-content_uCUqm`,
	"modalContent": `ae-preview-ext_modal-content_uCUqm`,
	"body": `ae-preview-ext_body_RWG9I`,
	"tab-button-enable": `ae-preview-ext_tab-button-enable_A9tOq`,
	"tabButtonEnable": `ae-preview-ext_tab-button-enable_A9tOq`,
	"tab-button-unable": `ae-preview-ext_tab-button-unable_CJiS5`,
	"tabButtonUnable": `ae-preview-ext_tab-button-unable_CJiS5`,
	"setting": `ae-preview-ext_setting_QS5uH`,
	"active": `ae-preview-ext_active_vrZNx`,
	"label": `ae-preview-ext_label_jCG5a`,
	"checkbox": `ae-preview-ext_checkbox_n1g2m`,
	"help-icon": `ae-preview-ext_help-icon__SfDK`,
	"helpIcon": `ae-preview-ext_help-icon__SfDK`,
	"custom-stage-size": `ae-preview-ext_custom-stage-size_yAJ16`,
	"customStageSize": `ae-preview-ext_custom-stage-size_yAJ16`,
	"custom-stage-size-input": `ae-preview-ext_custom-stage-size-input_GVJit`,
	"customStageSizeInput": `ae-preview-ext_custom-stage-size-input_GVJit`,
	"info": `ae-preview-ext_info_EGK7a`,
	"header": `ae-preview-ext_header__mRsF`,
	"divider": `ae-preview-ext_divider_HLna4`,
	"button": `ae-preview-ext_button_EWN7A`,
	"warning": `ae-preview-ext_warning_arnJK`,
	"svgItem": `ae-preview-ext_svgItem_aT8q4`
};
export default ___CSS_LOADER_EXPORT___;
